import { render, staticRenderFns } from "./TicketsRepository.vue?vue&type=template&id=1b7ca650&"
import script from "./TicketsRepository.vue?vue&type=script&lang=js&"
export * from "./TicketsRepository.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports